module.exports = __webpack_public_path__ + "static/img/rec_edges_l_b.87de8b22.png";